import type { AgentGenqlSelection } from '@rematter/frontend-lib-api-client';

export const agentFragment = {
  __typename: true,
  id: true,
  name: true,
  version: true,
  content: true,
  description: true,
  type: true,
  agentIdentifier: true,
  isActive: true,
  createdById: true,
  organizationId: true,
  tools: true,
  // AI Model Configuration
  modelProvider: true,
  model: true,
  providerApiKey: true,
  providerBaseUrl: true,
  reasoningEnabled: true,
  reasoningBudget: true,
  temperature: true,
  timestamps: {
    createdAt: true,
    updatedAt: true,
  },
} as const satisfies AgentGenqlSelection;
